import { Injectable } from '@angular/core';
import { FidelityProgramEventService } from './fidelity-program-event.service';
import {
  FidelityProgramEventName,
  ICompleteRegistrationEventModel,
  IParticipationInEventEventModel,
  ITutorDownloadMaterialEventModel,
  ITutorDownloadPrescriptionEventModel,
  ITutorPrintPrescriptionEventModel,
  IVetDownloadMaterialEventModel,
  IVetDownloadPrescriptionEventModel,
  IVetPrintPrescriptionEventModel,
  IWatchVideoEventModel
} from './models/fidelity-program-event-model';

@Injectable({
  providedIn: 'root'
})
export class SendingFidelityProgramEventsService {
  constructor(
    private fidelityProgramEventService: FidelityProgramEventService
  ) {}

  private getPage() {
    return window.location.pathname;
  }

  vetPrintPrescription(payload: IVetPrintPrescriptionEventModel) {
    return this.fidelityProgramEventService.emitFidelityProgramEvent({
      ...payload,
      eventName: FidelityProgramEventName.PRINT_PRESCRIPTION,
      page: this.getPage()
    });
  }

  tutorPrintPrescription(payload: ITutorPrintPrescriptionEventModel) {
    return this.fidelityProgramEventService.emitFidelityProgramEvent({
      ...payload,
      eventName: FidelityProgramEventName.PRINT_PRESCRIPTION,
      page: this.getPage()
    });
  }

  vetDownloadPrescription(payload: IVetDownloadPrescriptionEventModel) {
    return this.fidelityProgramEventService.emitFidelityProgramEvent({
      ...payload,
      eventName: FidelityProgramEventName.DOWNLOAD_PRESCRIPTION,
      page: this.getPage()
    });
  }

  tutorDownloadPrescription(payload: ITutorDownloadPrescriptionEventModel) {
    return this.fidelityProgramEventService.emitFidelityProgramEvent({
      ...payload,
      eventName: FidelityProgramEventName.DOWNLOAD_PRESCRIPTION,
      page: this.getPage()
    });
  }

  vetDownloadMaterial(payload: IVetDownloadMaterialEventModel) {
    return this.fidelityProgramEventService.emitFidelityProgramEvent({
      ...payload,
      eventName: FidelityProgramEventName.DOWNLOAD_MATERIAL,
      page: this.getPage()
    });
  }

  tutorDownloadMaterial(payload: ITutorDownloadMaterialEventModel) {
    return this.fidelityProgramEventService.emitFidelityProgramEvent({
      ...payload,
      eventName: FidelityProgramEventName.DOWNLOAD_MATERIAL,
      page: this.getPage()
    });
  }

  participationInEvent(payload: IParticipationInEventEventModel) {
    return this.fidelityProgramEventService.emitFidelityProgramEvent({
      ...payload,
      eventName: FidelityProgramEventName.PARTICIPATION_IN_EVENT,
      page: this.getPage()
    });
  }

  watchVideo(payload: IWatchVideoEventModel) {
    return this.fidelityProgramEventService.emitFidelityProgramEvent({
      ...payload,
      eventName: FidelityProgramEventName.WATCH_VIDEO,
      page: this.getPage()
    });
  }

  completeRegistration(payload: ICompleteRegistrationEventModel) {
    return this.fidelityProgramEventService.emitFidelityProgramEvent({
      ...payload,
      eventName: FidelityProgramEventName.COMPLETE_REGISTRATION,
      page: this.getPage()
    });
  }
}
